import { NewTextFormField } from 'components/formik/core/TextFormField/NewTextFormField';
import { Field } from 'formik';

interface FieldInputProps {
  name: string;
  label: string;
  disabled: boolean;
  id?: string;
}

const FieldInput = ({ name, label, id, disabled = false }: FieldInputProps) => (
  <Field
    name={name}
    component={NewTextFormField}
    type="string"
    label={label}
    variant="outlined"
    size="small"
    fullWidth
    disabled={disabled}
    id={id}
  />
);

export default FieldInput;
